export default {
    name: 'header',
    initialState: {
        height: 0,
    },
    reducers: {
        setHeaderHeight: (state, { payload }) => {
            state.height = payload;
        },
    },
};
